import React from 'react';
import { Link } from 'react-router-dom';
import gg_icon from '../../../images/logos/gg_logo_icon.png';
import MasterButton from '../../general_components/MasterButton/MasterButton';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import Dropdown_w_category from '../../general_components/Dropdown_w_category/Dropdown_w_category';
import money from '../../../utils/money';
import dates from '../../../utils/dates';

function formatDate(ymd) {
  if (!ymd) return '—';
  const s = String(ymd).slice(0, 10);
  if (s.length >= 10 && s.includes('-')) return dates.jsDate(s);
  return s || '—';
}

export default function Monthly_matching_summary(props) {
  const {
    details,
    guest,
    payment_methods,
    selected_payment_method,
    returnTo,
    paying,
    totalDueDollars,
    feeCents,
    onDDSelection,
    onGoToPayments,
    onPay,
  } = props;

  const totalMatchedCents = Number(details.total_matched_cents) || 0;
  const totalGiftsCents = Number(details.total_gifts_cents) != null ? Number(details.total_gifts_cents) : totalMatchedCents;
  const monthlyCapCents = Number(details.monthly_cap_cents) != null ? Number(details.monthly_cap_cents) : 0;

  return (
    <>
      <h2 className="monthly_matching_section_title">
        Gift matching summary for {details.month_label}
      </h2>

      <div className="monthly_matching_recipient_card">
        {details.media_url && (
          <div className="monthly_matching_recipient_img" style={{ backgroundImage: `url(${details.media_url})` }} />
        )}
        <div className="monthly_matching_recipient_name">{details.account_name}</div>
      </div>

      <div className="monthly_matching_summary">
        <h3 className="monthly_matching_summary_title">Matching Summary</h3>
        {details.gifts && details.gifts.length > 0 ? (
          <ul className="monthly_matching_gift_list">
            {details.gifts.map((g, i) => (
              <li key={g.gift_id || i} className="monthly_matching_gift_item">
                <div className="monthly_matching_gift_left">
                  <span>{details.account_name} received a gift</span>
                  <span className="monthly_matching_gift_date">{formatDate(g.date)}</span>
                </div>
                <span className="monthly_matching_gift_amount">${money.addCommas(Math.round((g.amount_cents || 0) / 100))}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="small_text">No gifts this month.</p>
        )}
        <div className="monthly_matching_total_line">
          <span>Total gifts this month:</span>
          <span className="monthly_matching_total_amount">${money.addCommas((totalGiftsCents / 100).toFixed(2))}</span>
        </div>
        {monthlyCapCents > 0 && (
          <div className="monthly_matching_total_line">
            <span>Your monthly cap:</span>
            <span>${money.addCommas((monthlyCapCents / 100).toFixed(2))}</span>
          </div>
        )}
        <div className="monthly_matching_total_line bold">
          <span>Amount due:</span>
          <span className="monthly_matching_total_amount">${money.addCommas((totalMatchedCents / 100).toFixed(2))}</span>
        </div>
      </div>

      <div className="monthly_matching_payment_section">
        <h3 className="monthly_matching_payment_title">Payment & confirmation</h3>
        <p className="monthly_matching_label">Payment method</p>
        <Dropdown_w_category
          dd_name="payment_method"
          header="Select Payment Method:"
          list={payment_methods}
          handleItemClick={onDDSelection}
          handleLastItemClick={onGoToPayments}
          selected={selected_payment_method}
          lastItem={true}
          last_item_add_button={true}
          lastItemText="Add a payment method"
          active={true}
        />
        
        <div className="monthly_matching_fees">
          <div className="monthly_matching_fee_line">
            <span>Convenience fee:</span>
            <span>${(feeCents / 100).toFixed(2)}</span>
          </div>
          <div className="monthly_matching_fee_line monthly_matching_total_due">
            <span>Total due:</span>
            <span>${totalDueDollars}</span>
          </div>
        </div>
        <div className="monthly_matching_actions">
          {paying ? (
            <GG_loader mini_loader={true} />
          ) : (
            <MasterButton
              buttonText={`PAY $${totalDueDollars} MATCHING`}
              handleButtonClick={onPay}
              notSticky={true}
              inactive_button={!selected_payment_method}
              disabled={!selected_payment_method}
            />
          )}
        </div>

        {selected_payment_method?.type === 'ACH' && (
          <div className="disclaimer_checkbox_container">
            <i className="material-icons-outlined disclaimer_checkbox">info</i>
            <p className="disclaimer_checkbox_text tiny_text">By confirming, you authorize Greatest Gift Inc. to electronically debit your account and, if necessary, electronically credit your account to correct erroneous debits.</p>
          </div>
        )}

        {guest && (
          <p className="monthly_matching_auth_links">
            <Link to={`/login?return_to=${encodeURIComponent(returnTo)}`} className="green_text">Log in</Link> to see saved payment methods
          </p>
        )}
      </div>

      <div className="gifting_footer">
        <a href="https://www.greatestgiftapp.com" target="_blank" rel="noreferrer">
          <img src={gg_icon} alt="gg icon" />
        </a>
        <p className="tiny_text">Greatest Gift Inc.</p>
        <p className="small_text">|</p>
        <a href="/legal?active=privacy" target="_blank" className="tiny_text" rel="noreferrer">Privacy</a>
        <a href="/legal" target="_blank" rel="noreferrer" className="tiny_text">Terms</a>
        <a href="https://www.greatestgiftapp.com/#faq" target="_blank" rel="noreferrer" className="tiny_text">FAQ</a>
      </div>
    </>
  );
}
